import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { WHITE } from '../../../constants/App';
import { LinkProps } from '../../../Interfaces/LinkProps';
import useStore from '../../../store/useStore';
import Lottie from 'lottie-react';
import { disableInteractiveElements } from '../../../Utils/WindowUtils';
import { getAnimationData } from '../../../Utils/InContextUtils';
const _global = (window || global) as any;

/**
 * Link component
 * @param param0.text text
 * @param param0.className custom class name
 * @returns react link component
 */
const Link: React.FC<LinkProps> = ({ href = '', text, className, style, onClick, analyticsData,testId,testAutoId,...props }) => {
  const onClickHandler = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    onClick && onClick(e);
    if (!isEmpty(analyticsData)) {
      _global.analytics.dashboardNotificationClick(
        analyticsData.sectionName,
        analyticsData.cta_Title.toLowerCase(),
      );
    }
  };
  const { contextLoader, setContextLoader } = useStore();
  const isLottieLoading = contextLoader?.isLoading && contextLoader.buttonId === testAutoId;
  const ariaLiveElement = document.getElementById('ariaLive');
  useEffect(() => {
    if (isLottieLoading) {
      if (!document.body.classList.contains('disableInteraction')) {
        disableInteractiveElements();
      }
      if (ariaLiveElement) { ariaLiveElement.innerText = contextLoader?.ariaLabelText }
    }

    return () => {
      if (document.body.classList.contains('disableInteraction')) {
        disableInteractiveElements();
          setContextLoader({animationColor: WHITE, buttonId: '', isLoading: false});
      }
      if (ariaLiveElement) { ariaLiveElement.innerText = '' }
    };
  }, [isLottieLoading]);

  return (
    <a
      href={href}
      onClick={e => {
        onClickHandler(e);
      }}
      className={className}
      style={style}
      data-testid={testId}
      data-testauto-id={testAutoId}
      {...props}
    >
       {isLottieLoading ? (
        <Lottie
          className={`in-context-loader`}
          animationData={getAnimationData(contextLoader.animationColor)}
        />
      ) : (
        <>
         {text}
        </>
      )}
    </a>
  );
};

export default Link;